import { StrictMode } from "react";

import { StyledEngineProvider } from "@mui/material/styles";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { store } from "./features/app/Store";
import { SomaAuthProvider } from "./features/auth/SomaAuthContext";
import reportWebVitals from "./reportWebVitals";
import { registerChartJs } from "./ChartJSRegistration";

registerChartJs();
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <Provider store={store}>
      <SomaAuthProvider>
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <App />
          </StyledEngineProvider>
        </BrowserRouter>
      </SomaAuthProvider>
    </Provider>
  </StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
